import axios from 'axios'
import store from '@/store'
import { getLocalData, getUrlPara2, getMobile, getPhoneType } from './utils'
import configObj from './config'

// 获取用户手机号
const getUserPhone = () => {
  const userInfo = getLocalData('userInfo') || {}
  const userName = getUrlPara2(location.search).userName || userInfo.userName || ''
  const mobile = getMobile(userName)
  return mobile
}

// 获取当前环境
const getEnv = () => {
  const host = window.location.host
  if (host.startsWith('y')) return '预发环境'
  if (host.startsWith('t')) return '测试环境'
  return '生产环境'
}

// 钉钉异常监控
export const sendDingtalk = async (msgText, msgType = 'markdown') => {
  // 如果是开发环境不发送钉钉消息
  if (process.env.NODE_ENV === 'development') return

  const envParams = {
    nodeEnv: getEnv(),
    nowDate: new Date().toLocaleString(),
    phoneType: getPhoneType(),
    userPhone: getUserPhone(),
    channelCode: store.getters.mdPackage
  }

  const messageContent = `
    环境：${envParams.nodeEnv}
    时间：${envParams.nowDate}
    机型：${envParams.phoneType}
    手机号：${envParams.userPhone}
    操作渠道：${envParams.channelCode}
    异常信息：${msgText}
  `

  const params = {
    robotType: '1', // robotType机器人类型：1异常提示机器人
    msgType: msgType, // msgType消息类型：1文本消息，2markdown消息
    sendContent: {
      'title': '通知',
      'text': messageContent
    }
  }
  return await axios.post(configObj.dingtalkRobotSendUrl, params)
}
